import { render, staticRenderFns } from "./donut.vue?vue&type=template&id=90a7afbc&"
import script from "./donut.vue?vue&type=script&lang=js&"
export * from "./donut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a7afbc')) {
      api.createRecord('90a7afbc', component.options)
    } else {
      api.reload('90a7afbc', component.options)
    }
    module.hot.accept("./donut.vue?vue&type=template&id=90a7afbc&", function () {
      api.rerender('90a7afbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/donut.vue"
export default component.exports